import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGamesContainerDomain = (state: any) => state.gamesContainer || initialState;

const selectGames = () => createSelector(selectGamesContainerDomain, (substate) => substate.games);
const selectIsLoading = () => createSelector(selectGamesContainerDomain, (substate) => substate.isLoading);
const selectError = () => createSelector(selectGamesContainerDomain, (substate) => substate.error);

// Pagination selectors
const selectCurrentPage = () => createSelector(selectGamesContainerDomain, (substate) => substate.currentPage);
const selectPageSize = () => createSelector(selectGamesContainerDomain, (substate) => substate.pageSize);
const selectTotalCount = () => createSelector(selectGamesContainerDomain, (substate) => substate.totalCount);
const selectTotalPages = () => createSelector(selectGamesContainerDomain, (substate) => substate.totalPages);

// Filter selector
const selectCurrentLeague = () => createSelector(selectGamesContainerDomain, (substate) => substate.currentLeague);

export {
  selectGames,
  selectIsLoading,
  selectError,
  selectCurrentPage,
  selectPageSize,
  selectTotalCount,
  selectTotalPages,
  selectCurrentLeague
};
